import type { PreviewTemplateRequest, PreviewTemplateResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export async function previewTemplate(
  workspaceSlug: string,
  request: PreviewTemplateRequest,
): Promise<PreviewTemplateResponse> {
  const response = await AuthAxios.post<PreviewTemplateResponse>(
    `/api/v1.0/e/${workspaceSlug}/notification-templates/preview`,
    request,
  )
  return response.data
}
